export default {
  website: {
    website_1001:
      'VHALL - live-streaming, web live-streaming, video live-streaming, online education platform, video live-streaming platform, web live-streaming system, the largest online live-streaming interactive platform in China',
    website_1002:
      'VHALL, VHALL live-streaming, online live-streaming, video conference, remote training, live-streaming software, live-streaming, live broadcast, web live-streaming, video live-streaming, web teaching platform, video conference software, online education platform, education online interactive platform, web video live-streaming platform, event planning live-streaming, multi-screen interactive browsing',
    website_1003:
      'VHALL, provider of professional global online business activity platform service, the largest web live-streaming platform; provides web live-streaming, online education and video conference services, supports multi-screen interactive browsing; rental hotline: 400-888-9970.',
    website_1004: 'Press ESC to exit full screen mode'
  },
  common: {
    common_1001: 'Loading...',
    common_1002: 'Desktop sharing container',
    common_1003: 'Invite',
    common_1004: 'Q&A',
    common_1005: 'Successful payment',
    common_1006: 'Please enter your phone/email/employee ID',
    common_1007: 'The detection type are inconsistent with the activity viewing restriction type',
    common_1008: 'Private chat',
    common_1009: 'Chinese',
    common_1010: 'Confirm',
    common_1011: 'Drag the slider to the right to fill the puzzle',
    common_1012: 'Starting time',
    common_1013: 'Online users',
    common_1014: 'w',
    common_1015: '100 million',
    common_1016: 'Trillion',
    common_1017: 'Activity Introduction',
    common_1018: 'Live-streaming',
    common_1019: 'Preview',
    common_1020: 'Finish',
    common_1021: 'Replay',
    common_1022: 'Timed live-streaming',
    common_1023: 'No delay',
    common_1024: 'On demand',
    common_1025: 'Subtitle',
    common_1026: 'Audio live broadcast',
    common_1027: 'video live-streaming',
    common_1028: 'Interactive live',
    common_1029: 'Grouping live',
    common_1030: 'Click',
    common_1031: 'The reservation number',
    common_1032: 'The number',
    common_1033: 'I got it',
    common_1034: 'Saved successfully',
    common_1035: '',
    common_1036: 'Vertical screen',
    common_1037: 'Introduction'
  },
  player: {
    player_1001: 'Heat',
    player_1002: 'Original',
    player_1003: 'HD',
    player_1004: 'SD',
    player_1005: 'FHD',
    player_1006: 'Audio',
    player_1007: 'Speed',
    player_1008: 'Switch',
    player_1009: 'Switch for you to',
    player_1010: 'To be presented soon...',
    player_1011: 'You have entered landscape mode',
    player_1012: 'Automatically continue from {n} where you stop last time.',
    player_1013: 'Watch now',
    player_1014: 'Voice is playing...',
    player_1015: 'Switch to {n} speed for you',
    player_1016: 'Replay',
    player_1017: 'The live-streaming has ended',
    player_1018: 'The live-streaming has started, please enjoy.',
    player_1019: 'Speed ​​setting failed',
    player_1020: 'Clarity setting failed',
    player_1021: 'Pause',
    player_1022: 'Play',
    player_1023: 'Failed to adjust the playback time',
    player_1024: 'Failed to set the time. Please try again later',
    player_1025: 'normal',
    player_1026: 'replaying',
    player_1027: 'There is no rehearsal now, please come again next time'
  },
  appointment: {
    appointment_1001: 'Whitelist verification',
    appointment_1002: 'Enter mobile phone number/email/employee ID',
    appointment_1003: 'Activity does not exist',
    appointment_1004: 'You have made an appointment successfully',
    appointment_1005:
      'Please visit this page to watch the live- streaming on the day of the live streaming',
    appointment_1006: 'Successful appointment',
    appointment_1007: 'Your information is not in the whitelist',
    appointment_1008: 'No whitelist',
    appointment_1009: 'Enter password',
    appointment_1010: 'Pay',
    appointment_1011: 'Invitation',
    appointment_1012: 'You can watch for {n} minutes for free. To watch the full video, please',
    appointment_1013: 'The trial is over, watch the full video',
    appointment_1014: 'Try again',
    appointment_1015: 'From live-streaming',
    appointment_1016: 'Broadcast',
    appointment_1017: 'Reserve Now',
    appointment_1018: '{n} Reserved',
    appointment_1019: "Nothing's here",
    appointment_1020: 'Permission validation',
    appointment_1021: 'Wrong password',
    appointment_1022: 'Please enter the password',
    appointment_1023: 'Pay {n}',
    appointment_1024: 'Please enter the invitation code',
    appointment_1025: 'Watch verification',
    appointment_1026: 'D',
    appointment_1027: 'H',
    appointment_1028: 'M',
    appointment_1029: 'S',
    appointment_1030: 'The event organizer set up a trial',
    appointment_1031: 'Please be patient',
    appointment_1032: 'Whitelist',
    appointment_1033: 'The rehearsal has started, please watch it live',
    appointment_1034: 'Submit and receive SMS',
    appointment_1035: 'Reserved'
  },
  nav: {
    nav_1001: 'Sponsor',
    nav_1002: 'WeChat',
    nav_1003: 'Followed',
    nav_1004: 'Follow',
    nav_1005: 'Log in',
    nav_1006: 'My live',
    nav_1007: 'Financial Center',
    nav_1008: 'My home page',
    nav_1009: 'Account settings',
    nav_1010: 'Exit',
    nav_1011: 'Sign out',
    nav_1012: 'Follow the Official Account',
    nav_1013: 'Share',
    nav_1014: 'Copy',
    nav_1015: 'Invitation',
    nav_1016: 'WeChat',
    nav_1017: 'Weibo',
    nav_1018: 'QQ',
    nav_1019: 'Scan on WeChat',
    nav_1020: 'Scan on WeChat to follow the official account',
    nav_1021: 'Long press',
    nav_1022: 'You can share the activity to friends or WeChat Moments',
    nav_1023: 'Get and forward your own exclusive invitation card',
    nav_1024: 'Copy successfully',
    nav_1025: 'Click to see more details',
    nav_1026: 'VHALL live-streaming',
    nav_1027: 'Click for details',
    nav_1028: 'Withdrawal',
    nav_1029: 'Unsubscribe',
    nav_1030: 'Followed',
    nav_1031: 'Long press',
    nav_1032: 'Top Inviters',
    nav_1033: 'Top Spenders',
    nav_1034: 'Rules',
    nav_1035: 'Rules',
    nav_1036: 'There are no rules',
    nav_1037: 'Invite {n} people',
    nav_1038: 'No one has invited you yet, so grab the couch',
    nav_1039: 'No prizes yet, so grab the sofa',
    nav_1040: "You haven't been invited, so grab the sofa",
    nav_1041: 'Tuhao, ask for reward',
    nav_1042: 'Invite friends to watch',
    nav_1043: 'To the bottom',
    nav_1044: 'Invite you to watch live together',
    nav_1045: 'Join Now!',
    nav_1046: 'Scan QR code',
    nav_1047: 'Long press and save',
    nav_1048: 'Time',
    nav_1049: 'Place',
    nav_1050: "The host hasn't opened the invitation yet",
    nav_1051: 'Alipay',
    nav_1052: 'Copy failed',
    nav_1053: 'Sponsor',
    nav_1054: 'Audience simulated viewing address during rehearsal',
    nav_1055: 'in rehearsal',
    nav_1056: 'Has been off the shelves',
    nav_1057: 'barrage open',
    nav_1058: 'barrage close'
  },
  login: {
    login_1001: 'Account login',
    login_1002: 'Log in with phone',
    login_1003: 'Verification code',
    login_1004: 'Password',
    login_1005: 'Auto login',
    login_1006: 'Log in immediately',
    login_1007: 'Not logged in',
    login_1008: 'Other login methods',
    login_1009: 'QQ Login',
    login_1010: 'Please enter your phone number/email',
    login_1011: 'Please enter your password',
    login_1012: 'Forgot the password',
    login_1013: 'Incorrect account or password',
    login_1014: 'Please set a login password (6-30 characters)',
    login_1015: 'Login Failed. Please login again.',
    login_1016: 'Exception request, operate failed',
    login_1017: 'Graphic code is not verified',
    login_1018: 'Please enter the graphic verification code',
    login_1019: 'Please enter your mobile phone number or email',
    login_1020: 'Please enter your account password',
    login_1021: 'Login failed',
    login_1022: 'Please enter your account number',
    login_1023: 'Graphic code error',
    login_1024: 'The two passwords are inconsistent!',
    login_1025: 'The two passwords are inconsistent!',
    login_1026: 'Log in',
    login_1027: 'Agree to the terms of service',
    login_1028: 's',
    login_1029: 'Mobile phone number verification failed, unable to operate',
    login_1030: 'Agree and abide by',
    login_1031: 'Terms of service',
    login_1032: 'Wechat login',
    login_1033: '',
    login_1034: '',
    login_1035: '',
    login_1036: '',
    login_1037: '',
    login_1038: '',
    login_1039: '',
    login_1040: '',
    login_1041: '',
    login_1042: '',
    login_1043: '',
    login_1044: 'Please enter phone number',
    login_1045: 'Verification code',
    login_1046: '',
    login_1047: '',
    login_1048: '',
    login_1049: '',
    login_1050: '',
    login_1051: '',
    login_1052: '',
    login_1053: '',
    login_1054: '',
    login_1055: '',
    login_1056: ' Please enter a valid phone number',
    login_1057: '',
    login_1058: '',
    login_1059: '',
    login_1060: ''
  },
  register: {
    register_1001: 'Welcome to register for VHALL live-streaming',
    register_1002: 'Register to be a new user',
    register_1003: 'Please check the agreement first',
    register_1004: 'Submission failed',
    register_1005: 'Sign up now',
    register_1006: 'The phone number has already been registered',
    register_1007: 'Set password (optional, 6-30 characters)',
    register_1008: 'I have read and agree',
    register_1009: 'Successful registration',
    register_1010: 'Registration failed',
    register_1011: 'Terms of Service and Privacy Agreement',
    register_1012: 'Please check the agreement first',
    register_1013: 'Register'
  },
  footer: {
    footer_1001: 'Feedback and report',
    footer_1002: 'Types',
    footer_1003: 'Viewing questions',
    footer_1004: 'Content & reports',
    footer_1005: 'Stuck',
    footer_1006: 'Blank screen',
    footer_1007: 'Sound and picture are out of sync',
    footer_1008: 'Assistant tool crashes',
    footer_1009: 'Problem with inserting video',
    footer_1010: 'Problem with camera setting',
    footer_1011: 'Audio problem',
    footer_1012: 'Software sharing source failed',
    footer_1013: 'Spreading illegal and bad information',
    footer_1014: 'Fraud',
    footer_1015: 'MLM',
    footer_1016: 'Cult',
    footer_1017: 'Describe',
    footer_1018: 'Make sure the description contains no more than 1000 characters',
    footer_1019: 'Question feedback success',
    footer_1020: 'Please describe the  problem',
    footer_1021: 'VHALL provides technical support'
  },
  chat: {
    chat_1001: '{n} and join the chat',
    chat_1002: 'Ask a question after {n}',
    chat_1003: 'Come and ask questions',
    chat_1004: 'Type in what you want to say',
    chat_1005: 'The content cannot be greater than 140 characters',
    chat_1006: 'You have been muted',
    chat_1007: 'You have been kicked out of the room',
    chat_1008: 'You have been banned from accessing the room',
    chat_1009: 'It can not be blank',
    chat_1010: 'Sent successfully',
    chat_1011: 'Failed to send',
    chat_1012: 'View organizer only',
    chat_1013: 'Special effects blocked',
    chat_1014: 'View the organizer only',
    chat_1015: '‘View the organizer only’ has been closed',
    chat_1016: 'Special effects blocked',
    chat_1017: 'Special effects on',
    chat_1018: 'Mine only',
    chat_1019: 'Mine only on',
    chat_1020: 'Mine only off',
    chat_1021: 'Join the chat',
    chat_1022: 'Host',
    chat_1023: 'Guest',
    chat_1024: 'Assistant',
    chat_1025: 'Submitted too frequently',
    chat_1026: '{n} unlocked',
    chat_1027: 'Sign-in initiated',
    chat_1028: 'Sign-in ended',
    chat_1029: 'Give a bonus',
    chat_1030: 'Sent a questionnaire',
    chat_1031: 'Check the details',
    chat_1032: 'Send out',
    chat_1033: 'Sent a bonus',
    chat_1034: 'Someone',
    chat_1035: '{n} unread messages',
    chat_1036: 'replied to',
    chat_1037: 'Impressive, Kudos!',
    chat_1038: 'Bonus being distributed',
    chat_1039: 'Answered this question in the live-streaming',
    chat_1040: 'Ask questions',
    chat_1041: 'Reply',
    chat_1042: 'Say something',
    chat_1043: 'Participating in interactive',
    chat_1044: 'You have been muted',
    chat_1045: 'Say something',
    chat_1056: 'Failed to send',
    chat_1057: 'It can not be blank',
    chat_1058: 'Viewing Historical Messages',
    chat_1059: 'you',
    chat_1060: 'Check the questionnaire',
    chat_1061: 'Send out',
    chat_1062: 'Undefined',
    chat_1063: 'Audience',
    chat_1064: '组长',
    chat_1065: 'Image loading failed',
    chat_1066: 'Please enter question',
    chat_1067: 'Please speak again in {n} seconds',
    chat_1068: 'The event site is too hit，please speak again in {n} seconds',
    chat_1069: 'Up to 140 words',
    chat_1070: '观众{n}结束了演示',
    chat_1071: '主持人已将您分配至{n}组',
    chat_1072: '主持人开启了分组讨论，您将进入{n}组参与讨论',
    chat_1073: '主持人结束了分组讨论，您将返回主直播间',
    chat_1074: '主持人解散了分组，您将返回主直播间',
    chat_1075: 'Someone @you',
    chat_1076: 'Someone replied to you',
    chat_1077: 'Whisper it to you',
    chat_1078: 'There is a new message',
    chat_1079: 'You have been muted',
    chat_1080: "So frequent. Please send in {n} S'",
    chat_1081: '{n} locked',
    chat_1082: '',
    chat_1083: '',
    chat_1084: '',
    chat_1085: '',
    chat_1086: 'Answered this question in the live-streaming',
    chat_1087: '',
    chat_1088: '',
    chat_1089: '',
    chat_1090: '',
    chat_1091: '',
    chat_1092: 'You have been muted',
    chat_1093: 'Click for details',
    chat_1094: 'Chat only',
    chat_1095: 'Setting',
    chat_1096: 'Chat only on',
    chat_1097: 'Chat only off',
    chat_1098: 'Click for details',
    chat_1099: 'Sent a'
  },
  form: {
    form_1001: 'Name',
    form_1002: 'Area',
    form_1003: 'Email',
    form_1004: 'Please select province',
    form_1005: 'Please select a city',
    form_1006: 'Please select district/county',
    form_1007: 'please enter your email',
    form_1008: 'Please enter the correct email format',
    form_1009: 'The email should not contain more than 80 letters',
    form_1010: 'Please enter the correct email address',
    form_1011: 'Unfold',
    form_1012: 'Hide',
    form_1013: 'Privacy statement',
    form_1014: 'please enter',
    form_1015: 'Male',
    form_1016: 'Female',
    form_1017: 'Please enter a description',
    form_1018: 'Please choose',
    form_1019: 'Sign up',
    form_1020: 'Verification code',
    form_1021: 'Get code',
    form_1022: 'Please enter the mobile phone number you filled in during registration',
    form_1023: 'Please enter your email',
    form_1024: 'I have signed up',
    form_1025: 'Sign up for the event',
    form_1026: 'Please enter your name',
    form_1027: 'Please select gender',
    form_1028: 'Please fill in details',
    form_1029: 'Please select content',
    form_1030: 'Please check the privacy agreement first',
    form_1031: 'Basic information of the registration form failed',
    form_1032:
      'The information is submitted successfully. The live-streaming will officially start on {n}, please come back on time!',
    form_1033: 'You have signed up and verified successfully',
    form_1034: 'Please sign up first',
    form_1035: 'Yes',
    form_1036: 'No',
    form_1037:
      'The questionnaire has been submitted successfully, thank you for your participation',
    form_1038: 'Please select from the options',
    form_1039: 'Selection cannot be empty',
    form_1040: 'Questionnaire title cannot be empty',
    form_1041: 'Please select from the options',
    form_1042: 'Please enter the detailed address',
    form_1043: 'Province/autonomous region/municipalities',
    form_1044: 'District/County',
    form_1045: 'Submit',
    form_1046: 'Select date',
    form_1047: 'Select date & time',
    form_1048: 'Select time',
    form_1049: 'Add column options',
    form_1050: 'Required',
    form_1051: 'Add row options',
    form_1052: 'Add options',
    form_1053: 'Please enter a title',
    form_1054: 'Company',
    form_1055: 'Gender',
    form_1056: 'Job title',
    form_1057: 'CEO/General Manager',
    form_1058: 'Chief Information Officer/IT Manager',
    form_1059: 'CMO/Manager',
    form_1060: 'Sales Director/Manager',
    form_1061: 'Technical Director/Manager',
    form_1062: 'Engineering technicians',
    form_1063: 'Other',
    form_1064: 'Mobile phone',
    form_1065: 'Day of birth',
    form_1066: 'Industry',
    form_1067: 'Educational background',
    form_1068: 'Select one answer',
    form_1069: 'Select multiple answers',
    form_1070: 'Q&A',
    form_1071: 'Drop-down question',
    form_1072: 'Subsection',
    form_1073: 'Title',
    form_1074: 'Survey',
    form_1075:
      'We protect all the information you fill in in accordance with the Privacy Statement.',
    form_1076: 'Verification code',
    form_1077: 'Options',
    form_1078: 'Form',
    form_1079: 'Password',
    form_1080: 'Make sure the description contains no more than 60 characters',
    form_1081: 'Please enter the mobile phone number you filled in during registration',
    form_1082: 'Verification',
    form_1083: 'This item is required',
    form_1084: 'Please enter the correct integer',
    form_1085: 'address',
    form_1086: '',
    form_1087: 'Submitted successfully, thank you for your participation',
    form_1088: 'Submitted successfully',
    form_1089: 'Fill in',
    form_1090: 'Filled',
    form_1091: 'My Gift'
  },
  menu: {
    menu_1001: 'Doc',
    menu_1002: 'Chat',
    menu_1003: 'Intro',
    menu_1004: 'Item',
    menu_1005: 'Ad',
    menu_1006: 'special',
    menu_1007: 'Buy',
    menu_1008: 'Product details',
    menu_1009: 'Visit shop',
    menu_1010: 'Check',
    menu_1011: 'No data',
    menu_1012: 'The default graphic',
    menu_1013: 'Chapter',
    menu_1014: 'Video',
    menu_1015: 'Audio'
  },
  interact_tools: {
    interact_tools_1001: 'Please enter the lottery title',
    interact_tools_1002: 'Lottery is in progress',
    interact_tools_1003: 'Lottery',
    interact_tools_1004: 'Please enter the address',
    interact_tools_1005: 'Please enter your name',
    interact_tools_1006: 'Receive award',
    interact_tools_1007: 'Send {n} to participate in the lottery',
    interact_tools_1008: 'Join now',
    interact_tools_1009: 'Prize',
    interact_tools_1010: 'You missed the jackpot',
    interact_tools_1011: 'Thank you for your participation',
    interact_tools_1012: 'Check winners',
    interact_tools_1013: 'Information submitted successfully!',
    interact_tools_1014: 'Information submission failed!',
    interact_tools_1015: 'Win the lottery!',
    interact_tools_1016: 'Congratulations on winning',
    interact_tools_1017: 'Claim your prize now',
    interact_tools_1018: 'Please enter information to receive your prize.',
    interact_tools_1019: 'Submit',
    interact_tools_1020: 'List of winners',
    interact_tools_1021: 'Lottery is in progress',
    interact_tools_1022: 'Unfortunately, you did not win a prize!',
    interact_tools_1023: 'Congratulations!',
    interact_tools_1024: 'Sign in',
    interact_tools_1025: 'Host initiates sign-in...',
    interact_tools_1026: 'Sign in now',
    interact_tools_1027: 'Sign in successfully',
    interact_tools_1028: 'Sign in failed',
    interact_tools_1029: 'Gift',
    interact_tools_1030: 'Give',
    interact_tools_1031: 'Successfully presented',
    interact_tools_1032: 'Thank you all for your support',
    interact_tools_1033: 'Deposited in  account',
    interact_tools_1034: 'Too slow!',
    interact_tools_1035: 'No red packet left~',
    interact_tools_1036: 'See others',
    interact_tools_1037: 'How to withdraw',
    interact_tools_1038:
      "WeChat users logged in can follow VHALL's WeChat official account and withdraw cash from the red packet income",
    interact_tools_1039:
      'Users logged in by other ways may log in PC terminal and withdraw in the [Withdraw Management] of your personal account',
    interact_tools_1040: '拼',
    interact_tools_1041: '普',
    interact_tools_1042: 'Best',
    interact_tools_1043: 'Receive {n}',
    interact_tools_1044: 'Reward',
    interact_tools_1045: 'Please select the reward amount',
    interact_tools_1046: 'Other amounts',
    interact_tools_1047: 'Impressive, Kudos!',
    interact_tools_1048: 'Payment method',
    interact_tools_1049: 'WeChat Pay',
    interact_tools_1050: 'Pay',
    interact_tools_1051: '[Scan] to pay',
    interact_tools_1052: 'Open',
    interact_tools_1053: 'Time out, start forward timing',
    interact_tools_1054: 'Countdown',
    interact_tools_1055: 'Paused',
    interact_tools_1056: 'Over',
    interact_tools_1057: 'In progress',
    interact_tools_1058: 'Free',
    interact_tools_1059: 'Coffee',
    interact_tools_1060: 'Love',
    interact_tools_1061: 'Applaud',
    interact_tools_1062: 'Rose',
    interact_tools_1063: 'Successfully presented',
    interact_tools_1064: 'Please choose a gift',
    interact_tools_1065: 'Send in your password {n} and enter the lottery',
    interact_tools_1066: 'Please fill in',
    interact_tools_1067: 'Fill in the successful',
    interact_tools_1068: 'The questionnaire has been submitted successfully',
    interact_tools_1069: 'Alipay Payment',
    interact_tools_1070: 'The amount supports up to two decimal places',
    interact_tools_1071: 'Reward amount exceeds limit',
    interact_tools_1072: 'QR code',
    interact_tools_1073: 'Reward {n}',
    interact_tools_1074: 'Unfortunately',
    interact_tools_1075: 'Applaud',
    interact_tools_1076: 'Records',
    interact_tools_1077: 'To get',
    interact_tools_1078: 'Got',
    interact_tools_1079: 'Winning',
    interact_tools_1080: 'Red envelope',
    interact_tools_1081: 'search" 口令红包" in Alipay, then enter the password',
    interact_tools_1082: 'Copy password',
    interact_tools_1083: 'View the detail',
    interact_tools_1085: 'TOP 10 list',
    interact_tools_1086: 'Notice',
    interact_tools_1087: 'Rocket',
    interact_tools_1088: 'Aircraft',
    interact_tools_1089: 'Salute',
    interact_tools_1090: 'Car',
    interact_tools_1091: 'Receive prizes',
    interact_tools_1092: 'Winning result',
    interact_tools_1093: 'This round of prize "{n}"',
    interact_tools_1094: 'No winner',
    interact_tools_1095: 'Name',
    interact_tools_1096: 'Phone Number',
    interact_tools_1097: 'Address',
    interact_tools_1098: 'bonus',
    interact_tools_1099: 'clock'
  },
  setting: {
    setting_1002: 'View settings',
    setting_1003: 'Camera',
    setting_1004: 'Microphone',
    setting_1005: 'Speaker',
    setting_1006: 'Screen',
    setting_1007: 'Picture',
    setting_1008: 'Device switching, please wait...',
    setting_1009: 'Default video stream placeholder image',
    setting_1010: 'Camera switch failed, please try again later',
    setting_1011: "Can't see the camera screen? Try the following methods:",
    setting_1012: 'Please allow the browser to use the camera',
    setting_1013: 'Make sure that the camera is not used by other programs',
    setting_1014: 'Choose an external camera or change the computer',
    setting_1015: 'Del',
    setting_1016: 'Suggested size: 1280*720px, less than 2MB,  jpg, png available',
    setting_1017: 'Please select a microphone',
    setting_1018: "Speak to the microphone, but can't see the fluctuation of the volume bar?",
    setting_1019: 'Try the following methods:',
    setting_1020: 'Please allow the browser to use the microphone',
    setting_1021: 'Make sure that the microphone is not used by other programs',
    setting_1022: 'Choose an external microphone or change the computer',
    setting_1023: 'Please select a speaker',
    setting_1024: 'Click here to play sound',
    setting_1025: "Can't hear the sound after clicking the play button? Try the following methods:",
    setting_1026: 'Please allow the browser to use sound',
    setting_1027: 'Please increase the speaker volume of the device',
    setting_1028: 'Choose external speakers or replace the computer',
    setting_1029: 'Help and support',
    setting_1030: 'Setting',
    setting_1031: 'Modifying settings will lead to re streaming. Do you want to continue saving',
    setting_1032: 'Setting',
    setting_1033: 'NO Equipment'
  },
  message: {
    message_1001: 'The organizer has encrypted the video. Recommend to use the computer to watch',
    message_1002: 'Video encryption prompt is not supported',
    message_1003: 'The event has been watched by the the account on other devices',
    message_1004: 'This video is not found!',
    message_1005: 'This topic is not found!',
    message_1006: 'This page has ceased to provide services.',
    message_1007: 'You have been banned from accessing the current event!',
    message_1008: 'The event is hit and the upper limit of audience has been exceeded!',
    message_1009:
      'Participating in the event as a host,guests or assistantsand cannot watch it.Recommend to clear the browser cookies before visiting~',
    message_1010: 'The network is running short',
    message_1011:
      'Your IE browser version is outdated, please upgrade to version IE10 and above. Recommend to use Chrome browser~',
    message_1012:
      'The embedded page only supports 3 authentication methods: default, password, third-party K value! If you cannot watch, please contact the event organizer',
    message_1013: 'The page is missing, an engineer is on the way...',
    message_1014: 'Video transcoding',
    message_1015: 'K value verification failed, about to jump',
    message_1016: 'Hosts, guests or assistants are not allowed to enter the viewing terminal',
    message_1017: 'The current version don‘t support viewing. Please use another browser',
    message_1018: 'The organizer has encrypted the video.',
    message_1019: 'It is recommended to use computer access to watch',
    message_1020: 'This video is currently unavailable.',
    message_1021: 'Unsupp',
    message_1022: 'The system is upgraded',
    message_1023: 'The system is upgraded from 00:00-07:00. We are sorry for any inconvenience.',
    message_1024: 'The event has been watched by the the account on other devices',
    message_1025: 'If you have any questions, please consult the link provider',
    message_1026: 'Information acquisition failed',
    message_1027: 'The host refreshed or left the page. Please wait a moment...',
    message_1028: 'Failed to create local preview stream',
    message_1029: '{n} leaves the room',
    message_1030: '{n} enter the room',
    message_1031: 'Check whether the device is disabled or occupied',
    message_1032: 'This item is required',
    message_1033: 'Invitation sent successfully',
    message_1034: 'Invitation sent successfully',
    message_1035: 'For better watching experience, please use landscape mode'
  },
  cash: {
    cash_1001: 'Manage balance',
    cash_1002: 'Available cash',
    cash_1003: 'Yuan',
    cash_1004: 'Withdrawing',
    cash_1005: 'withdrawn',
    cash_1006: 'The current balance is less than 1 Yuan, so withdrawal is not available.',
    cash_1007: 'Withdrawal instructions',
    cash_1008: 'What is the withdrawal limit for red pocket?',
    cash_1009:
      'Amount ranging from 1 to 800 Yuan can be withdrawn online at one time. At the request of State Taxation Administration, single withdrawal of more than 800 Yuan by individual users will incur personal income tax. Please send the following information to finance@vhall.com.',
    cash_1010:
      'Individual users: System account, name, ID number,Banking information (account holder, account number, bank name)',
    cash_1011:
      'Corporate users: Scanned copy of System account and business license with official sealBanking information (account holder, account number, bank name)',
    cash_1012:
      'Company/personal information and banking information must correspond with each other',
    cash_1013: 'Does the withdraw occur any charge, and if yes, how much?',
    cash_1014: 'No charge',
    cash_1015: 'How long will the income arrive after the withdrawal application?',
    cash_1016:
      '7-15 working days from the day of withdrawal and the actual arrival time shall prevail.',
    cash_1017: 'Are there any other precautions for withdrawal?',
    cash_1018:
      "You can't initiate a new withdrawal until the amount is credited to the bank account.",
    cash_1019: 'Grab a red envelope',
    cash_1020: 'No account change record',
    cash_1021: 'For the safety of your funds, please bind your mobile phone to your account.',
    cash_1022: 'Done and continue to withdraw',
    cash_1023: 'Scan QR-code with WeChat to blnd your account',
    cash_1024: 'Then the withdrawal will continue',
    cash_1025: 'Please enter the withdrawal amount',
    cash_1026: 'WeChat',
    cash_1027: 'Withdraw now',
    cash_1028: 'I consent',
    cash_1029: 'User Exchange Agreement',
    cash_1030: 'Please enter a numeric value',
    cash_1031: 'The withdrawal amount is at least  ¥1',
    cash_1032: 'The withdrawal amount must be less than the available amount',
    cash_1033: 'The verification result is unsuccessful and cannot be operated',
    cash_1034: 'The amount supports up to two decimal places',
    cash_1035: 'Please open it on wechat and apply for withdrawal',
    cash_1036: 'Withdrawal success',
    cash_1037: 'Withdrawal failed, unable to operate',
    cash_1038: 'Please enter the verification code',
    cash_1039: 'SMS verification code error',
    cash_1040: 'Could not confirm whether the user is bound to a withdrawal account'
  },
  account: {
    account_1001: 'Profile',
    account_1002: 'PN',
    account_1003: 'Enter mobile phone number',
    account_1004: 'MR',
    account_1005: 'Set up',
    account_1006: 'Name',
    account_1007: 'Save',
    account_1008: 'Revise',
    account_1009: 'Icon',
    account_1010: 'Suggested size: 140*140px',
    account_1011: 'Less than 2M',
    account_1012: 'jpg, gif, png, bmp available',
    account_1013: 'PWD',
    account_1014: 'Set',
    account_1015: 'Not set',
    account_1016: 'Change password',
    account_1017: 'Set password',
    account_1018: 'QQ',
    account_1019: 'Bound',
    account_1020: 'Unbound',
    account_1021: 'Unbind',
    account_1022: 'Bind now',
    account_1023: 'WeChat',
    account_1024: 'Set mobile phone',
    account_1025: 'Please enter phone number',
    account_1026: 'Change the phone number',
    account_1027: 'Enter mobile phone number',
    account_1028: 'Graphic code error',
    account_1029: 'Dynamic verification code',
    account_1030: 'Get code',
    account_1031: '{n}s',
    account_1032: 'Step 1: Verify the original phone number',
    account_1033: 'Please verify the bound phone number before modifying the phone number',
    account_1034: 'Step 2: Set up a new phone number',
    account_1035: 'Set up now',
    account_1036: 'Next',
    account_1037: 'Finish',
    account_1038: 'Set a new login password',
    account_1039: 'Enter the old login password',
    account_1040: 'Enter a new password',
    account_1041: 'Enter login password',
    account_1042: 'Repeat the new password',
    account_1043: 'Repeat the login password',
    account_1044: 'The cover image uploading can only be in png format',
    account_1045: 'Size of the cover image uploading cannot exceed 2MB',
    account_1046: 'Cover upload failed',
    account_1047: 'Profile picture modified successfully',
    account_1048: 'Profile picture modification failed',
    account_1049: 'Please enter your mobile number',
    account_1050: 'Phone number format is incorrect',
    account_1051: 'Failed to send verification code',
    account_1052: 'Mobile phone number verification failed, unable to operate',
    account_1053: 'Bind successfully',
    account_1054: 'Binding failed',
    account_1055: 'Nickname can not be blank',
    account_1056: 'Nickname length 1-30 characters',
    account_1057: 'Nickname modified successfully',
    account_1058: 'Nickname modification failed',
    account_1059: 'Successful operation',
    account_1060:
      'After unbinding QQ, you will not be able to log in with QQ. Are you sure you want to unbind?',
    account_1061: 'Tips',
    account_1062: 'Confirm',
    account_1063: 'Cancel',
    account_1064: 'Unbind successfully',
    account_1065: 'Unbinding failed',
    account_1066:
      'After unbinding WeChat, you will not be able to log in with WeChat. Are you sure you want to unbind?',
    account_1067: 'Cover',
    account_1068: 'Del',
    account_1069: 'Please enter a valid phone number',
    account_1070: 'Please enter the dynamic verification code',
    account_1071: 'Please enter the password!',
    account_1072: '6-30  Characters without spaces or special symbols!',
    account_1073: 'enter the password again!',
    account_1074: 'The two passwords are inconsistent!',
    account_1075: 'Modification of Personal Data',
    account_1076: 'Delete',
    account_1077: 'Prev',
    account_1078: 'This wechat has been bound, please unbind it first',
    account_1079: ' This QQ has been bound, please unbind it first'
  },
  interact: {
    interact_1001: 'Raise hand',
    interact_1002: 'The host turned off the raise hand function',
    interact_1003: 'You can raise your hand to apply for  turning on microphone',
    interact_1004: 'Wait',
    interact_1005: 'Turn off the microphone',
    interact_1006: 'Turn off the camera',
    interact_1007: 'Microphone off',
    interact_1008: 'The host invites you to open the microphone',
    interact_1009: 'Agree',
    interact_1010: 'Refuse',
    interact_1011:
      'The microphone connection is interrupted due to equipment problems, please check the equipment',
    interact_1012: '{n} is set to be the {m}',
    interact_1013:
      'Failed to subscribe to desktop sharing due to network problems. Subscribing again.',
    interact_1014: 'Failed to subscribe to user {n} due to network problems. Subscribing again.',
    interact_1015: 'Turn on the microphone',
    interact_1016: 'Check whether the device is disabled or occupied',
    interact_1017: 'Please open the microphone',
    interact_1018: 'Microphone off success',
    interact_1019:
      'The current browser or browser version does not support interaction. Upgrade the browser to the latest version or replace Chrome',
    interact_1020: 'or',
    interact_1021: 'Push flow failure',
    interact_1022: 'Turn on the camera',
    interact_1023: "The camera is turned off. The other party can't see you",
    interact_1024: 'Turn on the camera',
    interact_1025:
      'There is no response for a long time. As a result, the mai fails to be uploaded',
    interact_1026: 'The microphone is off. The other party cannot hear you',
    interact_1027: 'You have cancelled the raise hand',
    interact_1028: 'Microphone off success',
    interact_1029: 'The seats are full.Your account supports {n} people to get on the wheat',
    interact_1030: '{n} microphone off',
    interact_1031: '{n} invites you to open the microphone',
    interact_1032: '',
    interact_1033: 'home screen',
    interact_1034: 'presenter',
    interact_1035: 'Opposite party network exception',
    interact_1036:
      'The live broadcast is interrupted due to network problems. Please refresh the page and reconnect',
    interact_1037:
      'Currently on display, cannot apply for video connection at the moment, please try again later',
    interact_1038:
      'The organizer has turned on the video tour function, and you will see your video screen on the host\'s side. Please ensure that the video equipment is all normal, and click "{n}" to set the media.',
    interact_1039:
      'Only after obtaining the permission of camera and microphone can you participate in the connection',
    interact_1040:
      'To participate in the connection, you need to obtain the permission of camera and microphone,and go to the browser setting center to open permissions',
    interact_1041: 'Apply for video interaction',
    interact_1042: 'Check equipment',
    interact_1043: 'Are you sure you want to microphone off?'
  },
  doc: {
    doc_1001: 'This documentation is loading',
    doc_1002: "The presenter don't add a document",
    doc_1003: 'The presenter is preparing a document',
    doc_1004: 'This documentation is currently unavailable.',
    doc_1005: 'Zoom in',
    doc_1006: 'Zoom out',
    doc_1007: 'Move',
    doc_1008: 'Restore',
    doc_1009: 'Exit full screen mode',
    doc_1010: 'Full screen mode',
    doc_1011: '',
    doc_1012: '',
    doc_1013: '',
    doc_1014: '',
    doc_1015: '',
    doc_1016: '',
    doc_1017: '',
    doc_1018: '',
    doc_1019: '',
    doc_1020: '',
    doc_1021: '',
    doc_1022: '',
    doc_1023: '',
    doc_1024: '',
    doc_1025: '',
    doc_1026: '',
    doc_1027: '',
    doc_1028: 'Cancel Move',
    doc_1029: ''
  },
  webinar: {
    webinar_1001: 'Close',
    webinar_1002: 'No red packet left~',
    webinar_1003: 'Deposited in  account',
    webinar_1004: 'Wechat user could click the photo icon in the chatting area to withdraw',
    webinar_1005:
      'Other user could copy the watching link to browser, then click the photo icon after log in and withdraw the money',
    webinar_1006: 'No data',
    webinar_1007: 'Paused',
    webinar_1008: 'End of the timing',
    webinar_1009: 'On the clock',
    webinar_1010: 'Send out',
    webinar_1011: 'Please type in what you want to say',
    webinar_1012: 'Repeat sign in',
    webinar_1013: 'Duplicate cipher',
    webinar_1014:
      'Long press to copy the tao password content, use Taobao App to purchase or use a browser to open and view',
    webinar_1015: 'Enter',
    webinar_1016: 'It can only be accessed through the P terminal',
    webinar_1017: 'The Live streaming',
    webinar_1018: 'The Live streaming',
    webinar_1019: 'Started to remind',
    webinar_1020: 'Enter the activity',
    webinar_1021: 'Watch on demand',
    webinar_1022: 'Watch playback',
    webinar_1023: 'Watch live',
    webinar_1024: 'Pay',
    webinar_1025:
      'After binding the mobile phone number, you can receive SMS reminders, so that you will not miss the wonderful live broadcast',
    webinar_1026: 'The event has been watched by the the account on other devices',
    webinar_1027: 'In the morning',
    webinar_1028: 'AM',
    webinar_1029: 'PM',
    webinar_1030: 'Evening',
    webinar_1031: 'Continue to watch',
    webinar_1032: 'Click the refresh',
    webinar_1033: 'Mobile phone scan code to watch',
    webinar_1034: 'Qr code loaded failure',
    webinar_1035: 'Scan on WeChat to follow the official account',
    webinar_1036: 'Password activities',
    webinar_1037: 'Tourists***',
    webinar_1038: 'Share success',
    webinar_1039: 'Make an appointment',
    webinar_1040: 'Pay{n}',
    webinar_1041: 'Pay{n}',
    webinar_1042: 'The content you want has not been searched yet'
  },
  color: {
    color_1001: '',
    color_1002: '',
    color_1003: '',
    color_1004: '',
    color_1005: '',
    color_1006: '',
    color_1007: '',
    color_1008: '',
    color_1009: '',
    color_1010: '',
    color_1011: '',
    color_1012: ''
  },
  other: {
    other_1001: 'Preview image',
    other_1002: 'Enter the password!',
    other_1003: 'Enter the invitation code',
    other_1004: 'Upload image cannot exceed 2M',
    other_1005: '',
    other_1006: 'The host has not responded to your host request！',
    other_1007: 'Try sliding left and right',
    other_1008: 'wait',
    other_1009:
      'This live supports video connection， recommend allowing system opens corresponding device to use function.',
    other_1010: 'The current device does not support connection',
    other_1011: 'Allow “webinar.e.vhall.com” use your camera and Mic',
    other_1012: 'Refuse',
    other_1013: 'Allow',
    other_1014: 'Equipment inspection',
    other_1015: 'I got it',
    other_1016: 'K value verification failed',
    other_1017: 'Agree and continue',
    other_1018: 'Refuse',
    other_1019: 'got it',
    other_1020: "Unfortunately, we can't continue to serve you. You can close the page manually",
    other_1021:
      'Attention: Guests and assistants participate in the rehearsal through the official live broadcast address.',
    other_1022: 'VHALL',
    other_1023: 'apply for',
    other_1024: 'Get WeChat nickname and avatar information',
    other_1025:
      'Watch the live- streamingt,chat,lottery,grab a red envelope and other interactive behaviors',
    other_1026: 'Confirm',
    other_1027: 'Yes',
    other_1028: 'No'
  },
  privacy: {
    privacy_1001: 'Read and agree to the "{n}" and "{n1}"',
    privacy_1002: 'Submit and agree to the "{n}" and "{n1}"',
    privacy_1003: 'User Protection Agreement',
    privacy_1004: 'Privacy Policy',
    privacy_1005: 'Please read and agree to the Privacy Policy and User Service Agreement first',
    privacy_1006: 'Submit and agree to the "Privacy Policy" and "User Protection Agreement"',
    privacy_1007: 'Please check the agreement first'
  },
  exam: {
    exam_1001: 'Sent a answer',
    exam_1002: 'Start it',
    exam_1003: 'Publish',
    exam_1004: 'Score ranking',
    exam_1005: 'Count down',
    exam_1006: 'Unlimited',
    exam_1007: 'Answering',
    exam_1008: 'Great! Your answer is exactly right!',
    exam_1009: 'Unfortunately,your answer is wrong,keep trying!',
    exam_1010: 'Unfortunately,you have missed the opportunity!',
    exam_1011: 'Click for details',
    exam_1012: 'Viewing',
    exam_1013: 'score',
    exam_1014: 'Right answer',
    exam_1015: 'Your answer',
    exam_1016: 'Correct',
    exam_1017: 'Error',
    exam_1018: 'Unanswered',
    exam_1019: 'Last',
    exam_1020: 'Next',
    exam_1021: 'The results are being counted,please wait',
    exam_1022: 'Answer list',
    exam_1023: 'Push time',
    exam_1024: 'Time limit',
    exam_1025: 'Score',
    exam_1026: 'Number',
    exam_1027: 'Start it',
    exam_1028: 'Closed',
    exam_1029: 'Correct',
    exam_1030: 'Error',
    exam_1031: 'Unanswered',
    exam_1032: 'End of Answer,check the details',
    exam_1033: 'Full list',
    exam_1034: 'User',
    exam_1035: 'Accuracy',
    exam_1036: 'Time',
    exam_1037: 'My ranking',
    exam_1038: '{n}',
    exam_1039: 'Data is loading',
    exam_1040: 'End of Answer',
    exam_1041: 'Finished the answer',
    exam_1042: 'Full score',
    exam_1043: '',
    exam_1044: 'employee ID',
    exam_1045: 'Show the top 200 results',
    exam_1046: 'Unlimited',
    exam_1047: 'Answer',
    exam_1048: 'Sorce',
    exam_1049: 'Time',
    exam_1050: 'apply for '
  }
};
